<template>
  <div>
    <a-page-header title="Subscription Plans">
      <template slot="extra">
        <a-button key="1" type="primary" @click="addNewPlan()"
          >Add New Plan
        </a-button>
      </template>
    </a-page-header>
    <data-table
      ref="plansDataTable"
      :columns="columns"
      :data-source="plansState.plansList"
      :loading="loading"
      @refreshData="fetchData"
      rowKey="id"
      :totalCount="plansState.plansCount"
    >
      <span slot="isActive" slot-scope="record">
        <a-tag :color="record.isActive ? 'green' : 'volcano'">
          {{ (record.isActive ? "ACTIVE" : "DISABLED").toUpperCase() }}
        </a-tag>
      </span>

      <span slot="storageSize" slot-scope="record">
        <span> {{ `${record.storageSize}` }} GB </span>
      </span>

      <currency-column
        slot="price"
        slot-scope="record"
        v-model="record.price"
      />
      <date-time-column
        slot="creationDate"
        slot-scope="record"
        v-model="record.creationDate"
      />

      <span slot="action" slot-scope="record">
        <a class="edit-icon" @click="showEditModal(record.id)">
          <a-icon type="edit" />
        </a>
        <a-divider type="vertical" />
        <a class="trash-icon" @click="confirmDelete(record.id)">
          <a-icon type="delete" />
        </a>
      </span>
    </data-table>
    <EditPlanModal
      v-model="isModalVisible"
      :plan="editedPlan"
      :mode="modalMode"
      :businesses="businesses"
      :chargeCycles="chargeCycles"
    ></EditPlanModal>
  </div>
</template>

<script>
import { plansState, plansMutations } from "../../Store/store";
import { businessState, businessMutations } from "../../Store/store";
import { lookupState,lookupMutations } from "../../Store/store";
import EditPlanModal from "./EditPlanModal";

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: true,
    width: 250,
  },
  {
    title: "Business Name",
    dataIndex: "businessName",
    key: "businessName",
    sorter: true,
    width: 250,
  },
  {
    title: "Storage Size (GB)",
    key: "storageSize",
    sorter: true,
    scopedSlots: { customRender: "storageSize" },
  },
  {
    title: "Price",
    key: "price",
    sorter: true,
    scopedSlots: { customRender: "price" },
  },
  {
    title: "Charge Cycle",
    key: "chargeCycleName",
    dataIndex: "chargeCycleName",
    sorter: true,
  },
  {
    title: "Is Active",
    key: "isActive",
    sorter: true,
    scopedSlots: { customRender: "isActive" },
  },
  {
    title: "Creation Date",
    key: "creationDate",
    sorter: true,
    scopedSlots: { customRender: "creationDate" },
  },
  {
    title: "Actions",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: 70,
  },
];

export default {
  data() {
    return {
      columns,
      isModalVisible: false,
      businesses: [],
      chargeCycles: [],
      editedPlan: {},
      modalMode: "create",
      plansState: plansState,
      loading: false,
    };
  },
  async mounted() {
    await this.fetchData();
    await this.fetchBusinesses();
    await this.fetchChargeCycles();
  },
  methods: {
    async fetchData(params = {}) {
      this.loading = true;

      try {
        await plansMutations.getPlansList(params);
      } finally {
        this.loading = false;
      }
    },
    async fetchBusinesses() {
      await businessMutations.setBusinesses();
      this.businesses = businessState.businesses;
    },
    async fetchChargeCycles() {
      await lookupMutations.getChargeCycles();
      this.chargeCycles = lookupState.chargeCycles;
    },
    confirmDelete(planId) {
      const self = this;
      this.$confirm({
        title: "Please beware!",
        content: "Are you sure about deleting this plan?",
        okText: "Delete",
        okType: "danger",
        maskClosable: true,
        cancelText: "Cancel",
        async onOk() {
          const plan = self.plansState.plansList.find((u) => u.id === planId);

          if (plan) {
            try {
              await plansMutations.deletePlan(plan);
              self.$refs.plansDataTable.refreshData(true);
            } catch (error) {
              self.showError(error);
            }
          }
        },
      });
    },
    addNewPlan() {
      this.modalMode = "create";
      this.editedPlan = {};
      this.isModalVisible = true;
    },
    showEditModal(planId) {
      this.modalMode = "edit";
      this.editedPlan = {
        ...this.plansState.plansList.find((i) => i.id == planId),
      };
      this.isModalVisible = true;
    },
  },
  components: {
    EditPlanModal,
  },
};
</script>

<style scoped>
.trash-icon:hover {
  color: #bb2020;
}
.edit-icon:hover {
  color: #121317;
}
</style>
